import {useGlobals} from '../../../../globalPropsContext';
import {StatesButtonStates} from '@wix/wix-ui-tpa/cssVars';
import {AddToCartActionStatus, Experiments} from '../../../../constants';

export const useBaseAddToCartState = (productId: string, cardIndex?: number) => {
  const {addedToCartStatus, shouldShowAddToCartSuccessAnimation, addToCartInProgressSlotIndex, useExperiments} =
    useGlobals();
  const isCombinedListingEnabled = useExperiments.enabled(Experiments.CombinedListing);
  const isAddedSuccessfully = addedToCartStatus[productId] === AddToCartActionStatus.SUCCESSFUL;
  // null = no add-to-cart in progress; undefined = prop not passed (e.g. slider/category galleries)
  const isInProgress =
    addedToCartStatus[productId] === AddToCartActionStatus.IN_PROGRESS &&
    (!isCombinedListingEnabled ||
      addToCartInProgressSlotIndex === null ||
      addToCartInProgressSlotIndex === undefined ||
      addToCartInProgressSlotIndex === cardIndex);

  if (shouldShowAddToCartSuccessAnimation && isAddedSuccessfully) {
    return StatesButtonStates.SUCCESS;
  } else if (isInProgress) {
    return StatesButtonStates.IN_PROGRESS;
  }
  return StatesButtonStates.IDLE;
};
